import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationFormat'
})
export class DurationFormatPipe implements PipeTransform {

  transform(value: number): string {
    if (value == null || isNaN(value)) return '';

    if (value < 60) {
      return `${value} sec`;
    } else if (value < 3600) { // menos de una hora
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;
      return seconds > 0 ? `${minutes} min ${seconds} sec` : `${minutes} min`;
    } else { // más de una hora
      const hours = Math.floor(value / 3600);
      const minutes = Math.floor((value % 3600) / 60);
      return minutes > 0 ? `${hours} h ${minutes} min` : `${hours} h`;
    }
  }

}
